import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {
    httpCreateMedicalRecord,
    HttpCreateMedicalRecordOptions
} from '@/features/medical-records/http/medicalRecords.http'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {AxiosError} from 'axios'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {MedicalRecord} from '@/features/medical-records/types'

export const useCreateMedicalRecord = (
    options?: Omit<
        UseMutationOptions<Pick<MedicalRecord, 'id' | 'code'>, AxiosError, HttpCreateMedicalRecordOptions>,
        'mutationFn'
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_MEDICAL_RECORD],
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpCreateMedicalRecord(payload),
                onZodError: captureException,
                responseShape: MedicalRecord.pick({id: true, code: true})
            }),
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PATIENTS, variables.payload.patientId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
